import FaqsSidebar from "@/components/organisms/faqs-sidebar";
import StageHeader from "@/components/organisms/stage-header";
import { getByType, getDocument } from "@/lib/prismic";
import { FaqDocument, NavigationDocument } from "@/prismicio-types";
import { components } from "@/slices";
import { filter } from "@prismicio/client";
import { SliceZone } from "@prismicio/react";
import { notFound } from "next/navigation";
import { use } from "react";

type FaqsProps = {
  resolution: Resolution;
};

const Faqs = ({ resolution }: FaqsProps) => {
  const sidebarData = use(getDocument("navigation", "faq", resolution.locale)) as NavigationDocument;
  let faqData: FaqDocument | null;

  const [path] = resolution.slugs;

  if (path === "faq") {
    faqData = use(
      getByType("faq", resolution.locale, {
        pageSize: 1,
        filters: [filter.at("document.tags", ["faq-index"])],
      })
    )?.results[0] as FaqDocument;
  }
  faqData = use(getDocument("faq", path, resolution.locale)) as FaqDocument;

  if (!sidebarData || !faqData) return notFound();

  return (
    <>
      <StageHeader
        locale={resolution.locale}
        className="md:my-4 [&_h1]:mb-0"
        orientationOnMobile="left"
        title={faqData.data.title}
      />
      <div className="container flex flex-col gap-7.5 px-4 pb-7.5 md:p-7.5 lg:flex-row lg:gap-5 lg:pb-16">
        <FaqsSidebar slices={sidebarData.data.slices} locale={resolution.locale} />
        <article className="flex-1/2">
          <SliceZone components={components} slices={faqData.data.slices} />
        </article>
      </div>
    </>
  );
};

export default Faqs;
